import React from "react";
import ChangeProfilePicPresenter from "./ChangeProfilePicPresenter";
import ReporterType from "../../../infra/aggregates/reportsToInterface";

interface eventList {
  reporter: ReporterType;
}
const ChangeProfilePicController = ({ reporter }: eventList) => {
  return <ChangeProfilePicPresenter reporter={reporter} />;
};
export default ChangeProfilePicController;
